import styled, { keyframes } from "styled-components";

// Animação suave de entrada
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  /* Garante o box-sizing em todos os elementos filhos */
  & * {
    box-sizing: border-box;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  padding: 20px;
  font-family: "Poppins", sans-serif; /* Assumindo que a fonte já é carregada no projeto */
`;

export const Card = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  height: 85vh; /* Altura fixa para criar layout de app */
  max-height: 700px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${fadeIn} 0.4s ease-out;
  position: relative;
`;

export const Header = styled.div`
  padding: 30px 30px 20px 30px;
  background-color: #fff;
  border-bottom: 1px solid #f3f4f6;
  text-align: center;
  flex-shrink: 0;
  z-index: 2;
`;

export const Title = styled.h2`
  color: #111827;
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
`;

export const SubTitle = styled.p`
  color: #6b7280;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
`;

/* --- BUSCA --- */
export const SearchContainer = styled.div`
  padding: 15px 30px;
  background-color: #fff;
  flex-shrink: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 14px 15px 14px 45px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 15px;
  background-color: #f9fafb;
  color: #1f2937;
  outline: none;
  transition: all 0.2s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    background-color: #fff;
    border-color: #d4af37;
    box-shadow: 0 0 0 4px rgba(212, 175, 55, 0.1);
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
`;

/* --- LISTA --- */
export const ListContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px 30px 30px 30px;
  background-color: #fff;

  /* Custom Scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #e5e7eb;
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #d1d5db;
  }
`;

export const ConsultantItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 10px;
  background: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &:hover {
    border-color: #d4af37;
    background-color: #fffbf0; /* Amarelo bem claro */
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Avatar = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d4af37 0%, #b5952f 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  margin-right: 15px;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(212, 175, 55, 0.4);
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Name = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #374151;
`;

export const Role = styled.span`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
`;

/* --- TELA DE LOGIN/CONFIRMAÇÃO --- */
export const LoginContainer = styled.div`
  padding: 20px 30px 40px 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const SelectedCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: linear-gradient(to bottom right, #f9fafb, #f3f4f6);
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  margin-bottom: 25px;
`;

export const BigAvatar = styled(Avatar)`
  width: 70px;
  height: 70px;
  font-size: 24px;
  margin-right: 0;
  margin-bottom: 12px;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s;

  &:hover {
    color: #111827;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  display: block;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: all 0.2s;
  background-color: #fff;

  &:focus {
    border-color: #d4af37;
    box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
  }
`;

export const SubmitButton = styled.button`
  margin-top: 10px;
  width: 100%;
  padding: 14px;
  background: linear-gradient(to right, #d4af37, #c5a028);
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(212, 175, 55, 0.3);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 15px rgba(212, 175, 55, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const FeedbackBox = styled.div`
  margin-top: 15px;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  font-weight: 500;

  background-color: ${(props) =>
    props.type === "error" ? "#fee2e2" : "#dcfce7"};
  color: ${(props) => (props.type === "error" ? "#b91c1c" : "#15803d")};
  border: 1px solid
    ${(props) => (props.type === "error" ? "#fecaca" : "#bbf7d0")};
`;
